<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="3.013" height="13.058"><g data-name="Group 744" transform="rotate(90 1.506 1.507)" fill="#939393"><circle data-name="Ellipse 4" cx="1.507" cy="1.507" r="1.507"/><circle data-name="Ellipse 5" cx="1.507" cy="1.507" r="1.507" transform="translate(5.022)"/><circle data-name="Ellipse 6" cx="1.507" cy="1.507" r="1.507" transform="translate(10.045)"/></g></svg>
</template>
<script>
  export default {
    name: 'IconEllipse'
  }
</script>